import React, { useState, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import axios from 'axios';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import constants from '../../../constants';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const Filter = (props) => {
  const typeahead = useRef();
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [hotelList, setHotelList] = useState([]);

  const dateChangeRaw = (e) => {
    e.preventDefault();
  };

  const handleSearch = (hotel) => {
    if (typeof hotel === 'undefined' || hotel === '') {
      return;
    }
    if (hotel.length > 2) {
      getHotelList(hotel);
    }
  };

  const getHotelList = (hotel) => {
    setShowSearchLoader(true);
    axios(serverUrl + 'property/gethotellisting', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { page: 1, limit: 10, hotelName: hotel } }
    }).then(response => {
      if (response.data.status === 'success') {
        setHotelList(response.data.data.list);
      } else {
        // Optionally show error
      }
      setShowSearchLoader(false);
    }).catch(error => {
      console.log(error);
      setShowSearchLoader(false);
    });
  };

  const reset = () => {
    if (typeahead.current && typeahead.current.getInstance) typeahead.current.getInstance().clear();
    props.reset();
  };

  return (
    <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1">
      <div className="row gutters-5">
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <AsyncTypeahead
              ref={typeahead}
              inputProps={{ className: 'inputs' }}
              multiple={false}
              isLoading={showSearchLoader}
              options={hotelList}
              id={'hotel'}
              labelKey={'hotel'}
              minLength={3}
              align="justify"
              onSearch={handleSearch}
              placeholder={'Hotel'}
              filterBy={['hotel','hotel_code']}
              selectHintOnEnter
              onChange={selected => {
                props.paramChange(selected, 'hotelName');
              }}
              renderMenuItemChildren={(option, props) => (
                <span key={option.hotel_id} id={option.hotel_id}>
                  {option.hotel}
                </span>
              )}
            />
          </div>
        </div>
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <input
              type="text"
              placeholder="Booking Id"
              className="input pad_lft_rht10"
              value={props.params.bookingId}
              onChange={e => props.paramChange(e, 'bookingId')}
            />
          </div>
        </div>
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.requestType}
              onChange={e => props.paramChange(e, 'requestType')}
            >
              <option value="">Request Type</option>
              <option value="rate">Rate</option>
              <option value="inventory">Inventory</option>
              <option value="booking">Booking</option>
            </select>
          </div>
        </div>
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.status}
              onChange={e => props.paramChange(e, 'status')}
            >
              <option value="0">Status</option>
              <option value="error">Error</option>
              <option value="completed">Completed</option>
            </select>
          </div>
        </div>
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-calendar"></i>
            </span>
            <DatePicker
              inputProps={{ disabled: true }}
              placeholderText="Date"
              dateFormat="yyyy-MM-dd"
              className="input pad_lft_rht5"
              name="check_in"
              maxDate={new Date()}
              onChange={e => props.dateChange(e, 'date')}
              selected={props.params.date !== '' ? new Date(props.params.date) : null}
            />
          </div>
        </div>
        <div className="col-xs-12 col-md-auto marg_bottom10">
          <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={() => props.searchSyncLogs()}>
            <i className="fa fa-filter marg_right7"></i>Filter
          </div>
        </div>
        <div className="col-xs-12 col-md-auto marg_bottom10">
          <div className="btn2 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={reset}>
            <i className="fa fa-repeat marg_right7"></i>Reset
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
